export default __webpack_public_path__ + "static/media/03.267f86ae.png";